/**
 * Mobile Menu Toggle & Drawer Interaction Handler
 */
document.addEventListener('DOMContentLoaded', function () {
    const menuToggle = document.getElementById('menuToggle');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
    const mobileMenuBackdrop = document.getElementById('mobileMenuBackdrop');

    if (!menuToggle || !mobileMenuDrawer) {
        return;
    }

    function openMobileMenu() {
        mobileMenuDrawer.classList.add('is-open');
        mobileMenuDrawer.setAttribute('aria-hidden', 'false');
        menuToggle.classList.add('is-active');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        mobileMenuDrawer.classList.remove('is-open');
        mobileMenuDrawer.setAttribute('aria-hidden', 'true');
        menuToggle.classList.remove('is-active');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    menuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (mobileMenuDrawer.classList.contains('is-open')) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    if (mobileMenuBackdrop) {
        mobileMenuBackdrop.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenuDrawer.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });

    // Accordion interaction for sub-menus with children in mobile drawer
    const parentNavItems = mobileMenuDrawer.querySelectorAll('.mobile-nav-links .nav-item');
    parentNavItems.forEach(item => {
        const link = item.querySelector(':scope > a');
        const dropdown = item.querySelector(':scope > .nav-dropdown');

        if (link && dropdown) {
            link.addEventListener('click', function (e) {
                // If it has a submenu, toggle accordion
                e.preventDefault();
                e.stopPropagation();
                const isOpen = item.classList.contains('is-open');

                // Close other open sibling dropdowns for clean accordion effect
                parentNavItems.forEach(sibling => {
                    if (sibling !== item) {
                        sibling.classList.remove('is-open');
                    }
                });

                item.classList.toggle('is-open', !isOpen);
            });
        }
    });

    // Close menu when navigating via regular link or CTA in drawer
    const navigatableLinks = mobileMenuDrawer.querySelectorAll(
        '.mobile-nav-links li:not(.nav-item) > a, .mobile-nav-links .nav-dropdown a, .mobile-menu-cta'
    );
    navigatableLinks.forEach(link => {
        link.addEventListener('click', function () {
            closeMobileMenu();
        });
    });

    // Close menu on desktop resize
    window.addEventListener('resize', function () {
        if (window.innerWidth > 991 && mobileMenuDrawer.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });
});
